import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
// import TablesTemplate from './table_template';
import { ADD_ROW, AddItemToDropdown, ConvertStatus, DELETE_ROW, DROPDOWN_LIST_NONE, JSON_KEY_DATE, JSON_KEY_EXCHANGE, 
   JSON_KEY_ID, TABLE_HEADER_ID, 
   JSON_KEY_INSTRUMENT, JSON_KEY_MARKET, JSON_KEY_DESCRIPTION, JSON_KEY_PRIORITY, JSON_KEY_STATUS, 
   JSON_KEY_TIME, TABLE_HEADER_DATE, TABLE_HEADER_EXCHANGE, TABLE_HEADER_INSTRUMENT, 
   TABLE_HEADER_MARKET, TABLE_HEADER_DESCRIPTION, TABLE_HEADER_PRIORITY, TABLE_HEADER_STATUS, 
   TABLE_HEADER_TIME, UPDATE_ROW, 
   TABLE_HEADER_TRADING_RULES,
   JSON_KEY_TRADING_RULES,
   TABLE_HEADER_CODE,
   JSON_KEY_CODE,
   instrumentCodeColor,
   statusTextColor,
   rowOpacityForStatus} from '../../common/common';
import { Modal } from 'react-bootstrap';
import { selectIsMarketController, selectTSUserId } from '../../redux/globalsSlice';
import { useSelector } from 'react-redux';
import TradingEventsAdminForm from '../forms/trading_events_admin_form';
import { selectExchanges, selectInstruments, selectMarkets, selectTradingRules } from '../../redux/dropDownSlice';
import VirtualizedTablesTemplate from './VirtualizedTablesTemplate';

const TradingEvents2 = () => {
   const tsUserId = useSelector(selectTSUserId);
   const [showForm, setShowForm] = useState(false);
   const [selectedRow, setSelectedRow] = useState(null);
   const tsUserIdRef = useRef(tsUserId);
   const isMarketController = useSelector(selectIsMarketController);
   const isMarketControllerRef = useRef(isMarketController);
   const [dropDownTradingEventsData, setDropDownTradingEventsData] = useState([{ id: DROPDOWN_LIST_NONE, name: DROPDOWN_LIST_NONE }]);
   const dropDownExchangesData = useSelector(selectExchanges);
   const dropDownMarketsData = useSelector(selectMarkets);
   const dropDownInstrumentsData = useSelector(selectInstruments);
   const dropDownTradingRulesData = useSelector(selectTradingRules);
   

   useEffect(() => {
      tsUserIdRef.current = tsUserId;
   }, [tsUserId]);

   useEffect(() => {
      isMarketControllerRef.current = isMarketController;
   }, [isMarketController]);

   const handleCloseForm = () => {
      setShowForm(false); 
      setSelectedRow(null);
   };
   
   const handleSingleClick = useCallback((rowData) => {
      // console.log(`[TradingEventsTable] Row Clicked:`, rowData);
   }, []);

   const handleDoubleClick = useCallback((rowData) => {
      // console.log(`[TradingEventsTable] Row Double Clicked:`, rowData);
      if (isMarketControllerRef.current) {
         setSelectedRow(rowData);
         setShowForm(true);          
      }
   }, []);
   
   const handleEvents = useCallback((details, setLocalTableData) => {
      const { time, date, status } = details.data;
      
      // Format time (allow 0)
      let formattedTime = '';
      if (time !== undefined && time !== null && time !== '') {
         formattedTime = String(time).padStart(6, "0").replace(/(\d{2})(\d{2})(\d{2})/, "$1:$2:$3");
      }
      
      // Format date (allow 0)
      let formattedDate = '';
      if (date !== undefined && date !== null && date !== '') {
         formattedDate = String(date).padStart(6, "0").replace(/(\d{4})(\d{2})(\d{2})/, "$1-$2-$3");
      }
      
      const formattedRow = {
         ...details.data,
         date: formattedDate,
         time: formattedTime,
         status: ConvertStatus(status),
      };
   
      switch (details.type) {
         case ADD_ROW: {
            setLocalTableData(prev => {
               const isDuplicate = prev.some(row => row.id === formattedRow.id);
               if (isDuplicate) {
                  console.log(`[TradingEventsTable] Duplicate row ignored:`, formattedRow.id);
                  return prev;
               }
               return [...prev, formattedRow];
            });

            const label = details.data.code ? `${details.data.id}. ${details.data.code}`: `ID ${details.data.id}`;

            AddItemToDropdown(setDropDownTradingEventsData, { id: details.data.id, name: label});
            break;
         }
   
         case UPDATE_ROW:
            setLocalTableData(prev => prev.map(row => row.id === formattedRow.id ? formattedRow : row));
            break;
   
         case DELETE_ROW:
            setLocalTableData(prev => prev.filter(row => row.id !== formattedRow.id));
            break;

         default:
            break;
      }
   }, []);
   
   const columnStyling = useMemo(() => {
      const base = {};
      base[JSON_KEY_CODE] = (rowData) => ({
         color: instrumentCodeColor(rowData.status),
      });
      base[JSON_KEY_STATUS] = (rowData) => ({
         color: statusTextColor(rowData.status),
      });
      return base;
   }, []);

   const columns = useMemo(() => [
      { Header: TABLE_HEADER_ID, accessor: JSON_KEY_ID, }, // dont show it but it is still there
      { Header: TABLE_HEADER_CODE, accessor: JSON_KEY_CODE },
      { Header: TABLE_HEADER_PRIORITY, accessor: JSON_KEY_PRIORITY },
      // { Header: TABLE_HEADER_TRADING_RULES, accessor: JSON_KEY_CODE },
      { Header: TABLE_HEADER_DESCRIPTION, accessor: JSON_KEY_DESCRIPTION },
      { Header: TABLE_HEADER_TRADING_RULES, accessor: JSON_KEY_TRADING_RULES },
      { Header: TABLE_HEADER_TIME, accessor: JSON_KEY_TIME },
      { Header: TABLE_HEADER_DATE, accessor: JSON_KEY_DATE },
      { Header: TABLE_HEADER_EXCHANGE, accessor: JSON_KEY_EXCHANGE },
      { Header: TABLE_HEADER_MARKET, accessor: JSON_KEY_MARKET },
      { Header: TABLE_HEADER_INSTRUMENT, accessor: JSON_KEY_INSTRUMENT },
      { Header: TABLE_HEADER_STATUS, accessor: JSON_KEY_STATUS },
   ], []);

   return (
      <>
         <VirtualizedTablesTemplate
            columns={columns}
            eventHandlers={handleEvents}
            tableName="TradingEventsTable"
            onRowClick={handleSingleClick}
            enableSearch={true}
            onRowDoubleClick={handleDoubleClick}
            highlightOnClick={true}
            columnStyling={columnStyling}
            rowStyling={(row) => ({ opacity: rowOpacityForStatus(row.status) })}
         />
         <Modal show={showForm} onHide={handleCloseForm}>
            <TradingEventsAdminForm rowData={selectedRow} onClose={handleCloseForm} 
                                    tradingRulesOptions={dropDownTradingRulesData} 
                                    tradingEventOptions={dropDownTradingEventsData} 
                                    instrumentOptions={dropDownInstrumentsData} 
                                    exchangeOptions={dropDownExchangesData} 
                                    marketOptions={dropDownMarketsData}/>
         </Modal>
      </>
   );
};

export default TradingEvents2;
